import { useInstantWinsStore } from '@/stores/instant-wins'
import type { InstantWinDraw } from '@/types'
import type {
  NavigationGuardNext,
  RouteLocation,
  RouteRecordRaw,
} from 'vue-router'

export default [
  {
    path: '/instant-win/:instantWinCode',
    name: 'instant-win',
    component: () => import('../views/InstantWinsView.vue'),
  },
  {
    path: '/instant-win-terms-and-conditions/:instantWinCode',
    name: 'instant-win-terms-and-conditions',
    component: () => import('../views/Legal/InstantWinTermsLayoutProvider.vue'),
    meta: {
      title: (to: RouteLocation): string => {
        return `Instant Prize Draw: ${(to.meta.props as InstantWinDraw).title}`
      },
    },
    props: (route) => {
      return {
        instantWin: route.meta.props,
      }
    },
    async beforeEnter(
      to: RouteLocation,
      _from: RouteLocation,
      next: NavigationGuardNext
    ) {
      try {
        const instantWinCode = to.params.instantWinCode as string

        if (!instantWinCode) {
          return next({ name: 'not-found' })
        }

        const instantWinsStore = useInstantWinsStore()
        const instantWin = await instantWinsStore.getInstantWin(instantWinCode)

        if (!instantWin) {
          return next({ name: 'not-found' })
        }

        to.meta.props = instantWin

        next()
      } catch (e) {
        console.error(e)
        // redirect to NotFoundView
        return next({ name: 'not-found' })
      }
    },
  },
  /**
   * Route for playing an Instant Win game.
   */
  {
    path: '/instant-win-checkout/:instantWinCode/play',
    name: 'instant-wins-play',
    component: () => import('../views/InstantWinsView.vue'),
  },
  /**
   * Route for any Instant Win games that can be played in demo mode.
   */
  {
    path: '/instant-win/:instantWinCode/demo',
    name: 'instant-wins-demo',
    component: () => import('../views/InstantWinsView.vue'),
  },
  // -------------------------------- V1 routes --------------------------------
  // V1 post-checkout Instant Wins route. Redirects to v2 route
  {
    name: 'instant-win-checkout-order-confirmation',
    path: '/instant-win-checkout/:instantWinCode/order-confirmation',
    redirect: { name: 'instant-wins-play' },
  },
  // V1 post-checkout Mystery Box route. Redirects to v2 route
  {
    name: 'instant-win-checkout-open',
    path: '/instant-win-checkout/:instantWinCode/open',
    redirect: { name: 'instant-wins-play' },
  },
  // V1 post-checkout Instant Spin route. Redirects to v2 route
  {
    name: 'instant-win-checkout-spin',
    path: '/instant-win-checkout/:instantWinCode/spin',
    redirect: { name: 'instant-wins-play' },
  },
] as Readonly<RouteRecordRaw[]>
